import React from 'react';
import { token } from '@nib-components/theme';
import InfoBox from '@nib/info-box';
/**
 * A standard info box with a themed icon and border.
 */
export const StandardInfoBox = props => React.createElement(InfoBox, {
  iconAndBorderColor: token('theme.color.fg.info'),
  ...props
});